interface EventPayload {
    [key: string]: any
}
declare global {
    interface Window {
        gtag: (command: string, nameOrParams: string | EventPayload, params?: EventPayload) => void;
        posthog?: {
            capture: (name: string, properties?: EventPayload) => void;
        };
    }
}

export function logEvent(name: string, payload?: EventPayload) {
    if (typeof window === "undefined") return;

    if (typeof window.gtag === "function") {
        window.gtag("event", name, payload);
    }

    if (window.posthog?.capture) {
        window.posthog.capture(name, payload);
    }
}